// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

export default css`
  &.product-tile-layout {
    height: auto;
    .product-tile-img {
      max-height: 106px;
      border-radius: 6px;
    }
    .product-tile-img.search-redesign {
      width: 160px;
      height: auto;
      max-height: unset;
      max-width: unset;
      @media (min-width: 1200px) and (max-width: 1300px) {
        width: 111px;
      }
      @media (min-width: 1300px) and (max-width: 1500px) {
        width: 126px;
      }
      @media ${(props) => props.theme.mediaQuery.desktop} {
        width: 230px;
      }
      @media ${(props) => props.theme.mediaQuery.mediumOnly} {
        width: 94px;
      }
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        width: 114px;
      }
    }

    .featured-product-link div:first-child {
      height: auto;
    }
    .tile-discount {
      display: flex;
      margin-top: 2px;
    }
    .original-price {
      text-decoration: line-through;
    }
    .original-price.redesign {
      color: ${(props) => props.theme.colors.TEXT.DARKERGRAY};
      @media ${(props) => props.theme.mediaQuery.desktop} {
        font-size: ${(props) => props.theme.typography.fontSizes.fs12};
      }
    }
    .tile-discount-price.redesign {
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        font-size: ${(props) => props.theme.typography.fontSizes.fs15};
      }
      @media ${(props) => props.theme.mediaQuery.large} {
        font-size: ${(props) => props.theme.typography.fontSizes.fs14};
      }
      @media ${(props) => props.theme.mediaQuery.desktop} {
        font-size: ${(props) => props.theme.typography.fontSizes.fs20};
      }
    }
    .percentage_all_wrapped_normal_tab {
      margin-left: 5px;
    }
    .percentage_all_wrapped_normal_tab.redesign {
      color: ${(props) => props.theme.colors.NOTIFICATION.ERROR};
      @media ${(props) => props.theme.mediaQuery.desktop} {
        font-size: ${(props) => props.theme.typography.fontSizes.fs12};
      }
      line-height: initial;
    }
    .product-title-container {
      margin-top: 0;
      box-sizing: border-box;
      height: 36px;
      padding-top: 6px;
      ${(props) => props.searchEnhancementRedesign && `max-width:126px;`}
    }
    .product-name {
      ${(props) =>
        props.searchEnhancementRedesign &&
        `font-size:${props.theme.typography.fontSizes.fs12};font-weight:${props.theme.fonts.fontWeight.semiBold};`}
      @media ${(props) => props.theme.mediaQuery.mediumOnly} {
        ${(props) =>
          props.searchEnhancementRedesign && `font-size:${props.theme.typography.fontSizes.fs10};`}
      }
      @media ${(props) => props.theme.mediaQuery.desktop} {
        ${(props) =>
          props.searchEnhancementRedesign && `font-size:${props.theme.typography.fontSizes.fs14};`}
      }
    }
    .multiline-ellipsis {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .custom-ranking-container .rating-star-overlay {
      margin-top: -9px;
      width: calc(
        ${(props) =>
          `(${props.ratings} / 5) * ${
            (props.starRatingSize && props.starRatingSize.large) || 70
          }px`}
      );
    }
    .custom-ranking-container img {
      min-width: 70px;
      max-width: 70px !important;
      height: 12px;
    }
    .custom-ranking-container .rating-star-grey {
      margin-top: 5px;
    }
    .reviews-count {
      color: #1a1a1a;
      margin-top: 4px !important;
      font-size: 10px !important;
    }
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      .custom-ranking-container .rating-star-yellow {
        margin-top: 14px;
      }
    }
  }
`;
